<template>
    <vProjectPreview :views="views" v-model="chosenView">
        <vPreviewIframe
            v-if="isWallView && testimonials.length"
            :back="wall.transparentBackground ? '' : wall.wallColor"
            :src="`/preview/walls/${wall.uuid}`"
            :width="imageWidth"
        />
        <CardEmpty
            v-if="!testimonials.length && isWallView"
            class="w-full"
            :title="$t('love.empty.title')"
            :icon="emptyIcon"
            :ctaLabel="$t('love.empty.cta')"
            @add="createReview"
        />
        <vPreviewIframe
            v-if="isFormView"
            :back="wall.wallColor"
            :src="`/preview/review-ask/${wall.uuid}`"
        />
        <vPreviewIframe
            v-if="isMailView"
            :back="wall.formColors?.backgroundColor"
            :src="`/preview/love-mail/${wall.uuid}`"
        />
    </vProjectPreview>
</template>

<script>
import { markRaw } from "vue";
import { LOVE_PREVIEW_KIND, LOVE_ROUTE_NAMES } from "@/apps/love/love.routes";
import { mapActions, mapMutations, mapState } from "vuex";
import { LoveIcon, MailSendIcon, MailIcon } from "@easy/ui/icons";
import { CardEmpty } from "@easy/ui/cards";
import vPreviewIframe from "@/shared/views/vPreviewIframe.vue";
import vProjectPreview from "@/shared/views/vProjectPreview.vue";
import { useDebounceFn } from "@vueuse/core";
import { useStore } from "vuex";

export default {
    components: {
        vPreviewIframe,
        vProjectPreview,
        CardEmpty,
    },
    setup() {
        const store = useStore();

        const getEmailPreview = useDebounceFn(async () => {
            const emailHtml = await store.dispatch("love/getRequestEmailHtml");

            const iframe = store.state.love.iframe;

            if (iframe) {
                iframe.contentWindow.document.documentElement.innerHTML = emailHtml;
            }
        }, 350);

        return { getEmailPreview };
    },
    mounted() {
        this.$watch(
            () => [
                this.wall,
                this.testimonials,
                this.testimonial,
                this.size,
                this.chosenView,
                this.lang,
            ],
            () => this.refreshIframe(),
            {
                immediate: true,
                deep: true,
            }
        );
        this.$watch(
            () => this.chosenView,
            () => this.setIframeLoaded(false)
        );
        this.$watch(
            () => [this.isMailView, this.wallAskTitle, this.wallAskDesc, this.wallAskImg],
            () => {
                if (this.isMailView) {
                    this.getEmailPreview();
                }
            },
            {
                immediate: true,
            }
        );
    },
    data() {
        return {
            chosenView: LOVE_PREVIEW_KIND.wall,
        };
    },
    computed: {
        ...mapState(["lang"]),
        ...mapState("love", ["wall", "testimonials", "testimonial"]),
        ...mapState("love/uploads", ["imageWidth"]),
        emptyIcon() {
            return markRaw(LoveIcon);
        },
        views() {
            return [
                {
                    label: this.$t("love.views.wall"),
                    value: LOVE_PREVIEW_KIND.wall,
                    icon: markRaw(LoveIcon),
                },
                {
                    label: this.$t("love.views.form"),
                    value: LOVE_PREVIEW_KIND.form,
                    icon: markRaw(MailSendIcon),
                },
                {
                    label: this.$t("love.views.mail"),
                    value: LOVE_PREVIEW_KIND.mail,
                    icon: markRaw(MailIcon),
                },
            ];
        },
        isWallView() {
            return this.chosenView === LOVE_PREVIEW_KIND.wall;
        },
        isFormView() {
            return this.chosenView === LOVE_PREVIEW_KIND.form;
        },
        isMailView() {
            return this.chosenView === LOVE_PREVIEW_KIND.mail;
        },
        fontFamilyStyle() {
            return { "font-family": this.wall.fontFamily };
        },
        wallAskTitle() {
            return this.wall.askTitle;
        },
        wallAskDesc() {
            return this.wall.askDesc;
        },
        wallAskImg() {
            return this.wall.askImg;
        },
    },
    methods: {
        ...mapMutations("love", ["setIframeLoaded"]),
        ...mapActions("love", ["refreshIframe"]),
        createReview() {
            this.$router.push({
                name: LOVE_ROUTE_NAMES.projectReviewsList,
                query: { open: "create" },
            });
        },
    },
};
</script>
